import { render, staticRenderFns } from "./CustomSortable.vue?vue&type=template&id=54b81248&scoped=true&"
import script from "./CustomSortable.vue?vue&type=script&lang=js&"
export * from "./CustomSortable.vue?vue&type=script&lang=js&"
import style0 from "./CustomSortable.vue?vue&type=style&index=0&id=54b81248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b81248",
  null
  
)

export default component.exports